import {getUniqueString} from '@Utils/string.util';
import type {PendingInChatJob, PendingInChatJobId} from './in-chat-job-handoff.library.types';

const pendingJobs = new Map<PendingInChatJobId, PendingInChatJob>();
const handedOffJobIds = new Set<PendingInChatJobId>();

/** Registers a long in-chat job; each gets its own id so a later job is not treated as already handed off. */
export const markInChatJobPending = (job: PendingInChatJob): PendingInChatJobId => {
  const jobId = getUniqueString();
  pendingJobs.set(jobId, job);
  return jobId;
};

/** Called when the job settles. Read `isInChatJobHandedOffToGrowl` first: this forgets the job's handoff. */
export const clearPendingInChatJob = (jobId: PendingInChatJobId): void => {
  pendingJobs.delete(jobId);
  handedOffJobIds.delete(jobId);
};

export const isInChatJobHandedOffToGrowl = (jobId: PendingInChatJobId): boolean => {
  return handedOffJobIds.has(jobId);
};

export const hasPendingInChatJobs = (): boolean => {
  return pendingJobs.size > 0;
};

/** The loading modal was closed mid-run: jobs not yet handed off report through a growl from now on. */
export const handOffPendingInChatJobsToGrowl = (): void => {
  pendingJobs.forEach((job, jobId): void => {
    if (handedOffJobIds.has(jobId)) {
      return;
    }
    handedOffJobIds.add(jobId);
    job.showOngoingGrowl();
  });
};
